export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const REGISTRATION_START = 'REGISTRATION_START';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const REGISTRATION_FAIL = 'REGISTRATION_FAIL';
export const REGISTRATION_UNMOUNT = 'REGISTRATION_UNMOUNT';

export const REGISTRATION_CONFIRM_START = 'REGISTRATION_CONFIRM_START';
export const REGISTRATION_CONFIRM_SUCCESS = 'REGISTRATION_CONFIRM_SUCCESS';
export const REGISTRATION_CONFIRM_FAIL = 'REGISTRATION_CONFIRM_FAIL';

export const RESET_PASSWORD_START = 'RESET_PASSWORD_START';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';
export const RESET_PASSWORD_UNMOUNT = 'RESET_PASSWORD_UNMOUNT';

export const RESET_PASSWORD_CONFIRM_START = 'RESET_PASSWORD_CONFIRM_START';
export const RESET_PASSWORD_CONFIRM_SUCCESS = 'RESET_PASSWORD_CONFIRM_SUCCESS';
export const RESET_PASSWORD_CONFIRM_FAIL = 'RESET_PASSWORD_CONFIRM_FAIL';

export const CHANGE_PASSWORD_START = 'CHANGE_PASSWORD_START';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL';

export const CHANGE_PROFILE_START = 'CHANGE_PROFILE_START';
export const CHANGE_PROFILE_SUCCESS = 'CHANGE_PROFILE_SUCCESS';
export const CHANGE_PROFILE_FAIL = 'CHANGE_PROFILE_FAIL';
export const CHANGE_PROFILE_UNMOUNT = 'CHANGE_PROFILE_UNMOUNT';

export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
export const GET_USER_ME_SUCCESS = 'GET_USER_ME_SUCCESS';
export const GET_USER_ME_FAIL = 'GET_USER_ME_FAIL';

export const FETCH_COURSES_START = 'FETCH_COURSES_START';
export const FETCH_COURSES_SUCCESS = 'FETCH_COURSES_SUCCESS';
export const FETCH_COURSES_FAIL = 'FETCH_COURSES_FAIL';

export const FETCH_SINGLE_COURSE_START = 'FETCH_SINGLE_COURSE_START';
export const FETCH_SINGLE_COURSE_SUCCESS = 'FETCH_SINGLE_COURSE_SUCCESS';
export const FETCH_SINGLE_COURSE_FAIL = 'FETCH_SINGLE_COURSE_FAIL';
export const FETCH_SINGLE_COURSE_UNMOUNT = 'FETCH_SINGLE_COURSE_UNMOUNT';

export const FETCH_COURSE_ACCESS_START = 'FETCH_COURSE_ACCESS_START';
export const FETCH_COURSE_ACCESS_SUCCESS = 'FETCH_COURSE_ACCESS_SUCCESS';
export const FETCH_COURSE_ACCESS_FAIL = 'FETCH_COURSE_ACCESS_FAIL';
export const FETCH_COURSE_ACCESS_UNMOUNT = 'FETCH_COURSE_ACCESS_UNMOUNT';

export const FETCH_SINGLE_LESSON_START = 'FETCH_SINGLE_LESSON_START';
export const FETCH_SINGLE_LESSON_SUCCESS = 'FETCH_SINGLE_LESSON_SUCCESS';
export const FETCH_SINGLE_LESSON_FAIL = 'FETCH_SINGLE_LESSON_FAIL';
export const SINGLE_LESSON_UNMOUNT = 'SINGLE_LESSON_UNMOUNT';

export const FETCH_SINGLE_LESSON_SHARED_START = 'FETCH_SINGLE_LESSON_SHARED_START';
export const FETCH_SINGLE_LESSON_SHARED_SUCCESS = 'FETCH_SINGLE_LESSON_SHARED_SUCCESS';
export const FETCH_SINGLE_LESSON_SHARED_FAIL = 'FETCH_SINGLE_LESSON_SHARED_FAIL';
export const SINGLE_LESSON_SHARED_UNMOUNT = 'SINGLE_LESSON_SHARED_UNMOUNT';

export const LESSON_WATCHED_START = 'LESSON_WATCHED_START';
export const LESSON_WATCHED_SUCCESS = 'LESSON_WATCHED_SUCCESS';
export const LESSON_WATCHED_FAIL = 'LESSON_WATCHED_FAIL';
export const COURSE_MODULES_UPDATE_LESSON_META = 'COURSE_MODULES_UPDATE_LESSON_META';

export const LESSON_FAVORITE_START = 'LESSON_FAVORITE_START';
export const LESSON_FAVORITE_SUCCESS = 'LESSON_FAVORITE_SUCCESS';
export const LESSON_FAVORITE_FAIL = 'LESSON_FAVORITE_FAIL';

export const SET_LESSON_NOTES_START = 'SET_LESSON_NOTES_START';
export const SET_LESSON_NOTES_SUCCESS = 'SET_LESSON_NOTES_SUCCESS';
export const SET_LESSON_NOTES_FAIL = 'SET_LESSON_NOTES_FAIL';

export const JUMP_TO_LESSON = 'JUMP_TO_LESSON';
export const JUMP_TO_LESSON_REVERT = 'JUMP_TO_LESSON_REVERT';

export const FETCH_FAVORITE_LESSONS_START = 'FETCH_FAVORITE_LESSONS_START';
export const FETCH_FAVORITE_LESSONS_SUCCESS = 'FETCH_FAVORITE_LESSONS_SUCCESS';
export const FETCH_FAVORITE_LESSONS_FAIL = 'FETCH_FAVORITE_LESSONS_FAIL';

export const FETCH_COURSE_MODULES_START = 'FETCH_COURSE_MODULES_START';
export const FETCH_COURSE_MODULES_SUCCESS = 'FETCH_COURSE_MODULES_SUCCESS';
export const FETCH_COURSE_MODULES_FAIL = 'FETCH_COURSE_MODULES_FAIL';
export const FETCH_COURSE_MODULES_UNMOUNT = 'FETCH_COURSE_MODULES_UNMOUNT';

export const NATURAL_PERSON_ORDER_START = 'NATURAL_PERSON_ORDER_START';
export const NATURAL_PERSON_ORDER_SUCCESS = 'NATURAL_PERSON_ORDER_SUCCESS';
export const NATURAL_PERSON_ORDER_FAIL = 'NATURAL_PERSON_ORDER_FAIL';
export const LEGAL_ORDER_START = 'LEGAL_ORDER_START';
export const LEGAL_ORDER_SUCCESS = 'LEGAL_ORDER_SUCCESS';
export const LEGAL_ORDER_FAIL = 'LEGAL_ORDER_FAIL';
export const ORDER_UNMOUNT = 'ORDER_UNMOUNT';

export const REJECT_ORDER_START = 'REJECT_ORDER_START';
export const REJECT_ORDER_SUCCESS = 'REJECT_ORDER_SUCCESS';
export const REJECT_ORDER_FAIL = 'REJECT_ORDER_FAIL';

export const FETCH_MY_COURSES_START = 'FETCH_MY_COURSES_START';
export const FETCH_MY_COURSES_SUCCESS = 'FETCH_MY_COURSES_SUCCESS';
export const FETCH_MY_COURSES_FAIL = 'FETCH_MY_COURSES_FAIL';

export const FETCH_INSTRUCTORS_START = 'FETCH_INSTRUCTORS_START';
export const FETCH_INSTRUCTORS_SUCCESS = 'FETCH_INSTRUCTORS_SUCCESS';
export const FETCH_INSTRUCTORS_FAIL = 'FETCH_INSTRUCTORS_FAIL';

export const FETCH_SINGLE_INSTRUCTOR_START = 'FETCH_SINGLE_INSTRUCTOR_START';
export const FETCH_SINGLE_INSTRUCTOR_SUCCESS = 'FETCH_SINGLE_INSTRUCTOR_SUCCESS';
export const FETCH_SINGLE_INSTRUCTOR_FAIL = 'FETCH_SINGLE_INSTRUCTOR_FAIL';
export const SINGLE_INSTRUCTOR_UNMOUNT = 'SINGLE_INSTRUCTOR_UNMOUNT';

export const FETCH_SINGLE_INSTRUCTOR_COURSES_START = 'FETCH_SINGLE_INSTRUCTOR_START';
export const FETCH_SINGLE_INSTRUCTOR_COURSES_SUCCESS = 'FETCH_SINGLE_INSTRUCTOR_COURSES_SUCCESS';
export const FETCH_SINGLE_INSTRUCTOR_COURSES_FAIL = 'FETCH_SINGLE_INSTRUCTOR_COURSES_FAIL';
export const SINGLE_INSTRUCTOR_COURSES_UNMOUNT = 'SINGLE_INSTRUCTOR_UNMOUNT';

export const FETCH_BLOG_START = 'FETCH_BLOG_START';
export const FETCH_BLOG_SUCCESS = 'FETCH_BLOG_SUCCESS';
export const FETCH_BLOG_FAIL = 'FETCH_BLOG_FAIL';

export const FETCH_SINGLE_BLOG_START = 'FETCH_SINGLE_BLOG_START';
export const FETCH_SINGLE_BLOG_SUCCESS = 'FETCH_SINGLE_BLOG_SUCCESS';
export const FETCH_SINGLE_BLOG_FAIL = 'FETCH_SINGLE_BLOG_FAIL';
export const SINGLE_BLOG_UNMOUNT = 'SINGLE_BLOG_UNMOUNT';

export const CONTACT_FORM_START = 'CONTACT_FORM_START';
export const CONTACT_FORM_SUCCESS = 'CONTACT_FORM_SUCCESS';
export const CONTACT_FORM_FAIL = 'CONTACT_FORM_FAIL';
export const CONTACT_FORM_UNMOUNT = 'CONTACT_FORM_UNMOUNT';

export const REQUEST_COURSE_START = 'REQUEST_COURSE_START';
export const REQUEST_COURSE_SUCCESS = 'REQUEST_COURSE_SUCCESS';
export const REQUEST_COURSE_FAIL = 'REQUEST_COURSE_FAIL';
export const REQUEST_COURSE_UNMOUNT = 'REQUEST_COURSE_UNMOUNT';

export const FETCH_TESTIMONIALS_START = 'FETCH_TESTIMONIALS_START';
export const FETCH_TESTIMONIALS_SUCCESS = 'FETCH_TESTIMONIALS_SUCCESS';
export const FETCH_TESTIMONIALS_FAIL = 'FETCH_TESTIMONIALS_FAIL';
export const FETCH_TESTIMONIALS_UNMOUNT = 'FETCH_TESTIMONIALS_UNMOUNT';

export const COOKIE_CONFIRM_START = 'COOKIE_CONFIRM_START';
export const COOKIE_CONFIRM_SUCCESS = 'COOKIE_CONFIRM_SUCCESS';
export const COOKIE_CONFIRM_FAIL = 'COOKIE_CONFIRM_FAIL';

export const SITE_INFO_CLOSE_START = 'SITE_INFO_CLOSE_START';
export const SITE_INFO_CLOSE_SUCCESS = 'SITE_INFO_CLOSE_SUCCESS';
export const SITE_INFO_CLOSE_FAIL = 'SITE_INFO_CLOSE_FAIL';

export const FETCH_PODCASTS_START = 'FETCH_PODCASTS_START';
export const FETCH_PODCASTS_SUCCESS = 'FETCH_PODCASTS_SUCCESS';
export const FETCH_PODCASTS_FAIL = 'FETCH_PODCASTS_FAIL';

export const FETCH_SINGLE_PODCAST_START = 'FETCH_SINGLE_PODCAST_START';
export const FETCH_SINGLE_PODCAST_SUCCESS = 'FETCH_SINGLE_PODCAST_SUCCESS';
export const FETCH_SINGLE_PODCAST_FAIL = 'FETCH_SINGLE_PODCAST_FAIL';
export const SINGLE_PODCAST_UNMOUNT = 'SINGLE_PODCAST_UNMOUNT';

export const FETCH_TEST_START = 'FETCH_TEST_START';
export const FETCH_TEST_SUCCESS = 'FETCH_TEST_SUCCESS';
export const FETCH_TEST_FAIL = 'FETCH_TEST_FAIL';
export const FETCH_TEST_UNMOUNT = 'FETCH_TEST_UNMOUNT';

export const SUBMIT_TEST_START = 'SUBMIT_TEST_START';
export const SUBMIT_TEST_SUCCESS = 'SUBMIT_TEST_SUCCESS';
export const SUBMIT_TEST_FAIL = 'SUBMIT_TEST_FAIL';
export const SUBMIT_TEST_UNMOUNT = 'SUBMIT_TEST_UNMOUNT';

export const FETCH_TEST_INFO_START = 'FETCH_TEST_INFO_START';
export const FETCH_TEST_INFO_SUCCESS = 'FETCH_TEST_INFO_SUCCESS';
export const FETCH_TEST_INFO_FAIL = 'FETCH_TEST_INFO_FAIL';
export const FETCH_TEST_INFO_UNMOUNT = 'FETCH_TEST_INFO_UNMOUNT';

export const FETCH_TEST_ATTEMPTS_START = 'FETCH_TEST_ATTEMPTS_START';
export const FETCH_TEST_ATTEMPTS_SUCCESS = 'FETCH_TEST_ATTEMPTS_SUCCESS';
export const FETCH_TEST_ATTEMPTS_FAIL = 'FETCH_TEST_ATTEMPTS_FAIL';
export const FETCH_TEST_ATTEMPTS_UNMOUNT = 'FETCH_TEST_ATTEMPTS_UNMOUNT';

export const POST_PAID_SLOT_START = 'POST_PAID_SLOT_START';
export const POST_PAID_SLOT_SUCCESS = 'POST_PAID_SLOT_SUCCESS';
export const POST_PAID_SLOT_FAIL = 'POST_PAID_SLOT_FAIL';

export const FETCH_PAID_SLOTS_START = 'FETCH_PAID_SLOTS_START';
export const FETCH_PAID_SLOTS_SUCCESS = 'FETCH_PAID_SLOTS_SUCCESS';
export const FETCH_PAID_SLOTS_FAIL = 'FETCH_PAID_SLOTS_FAIL';
export const FETCH_PAID_SLOTS_UNMOUNT = 'FETCH_PAID_SLOTS_UNMOUNT';

/**
 * Course packages
 */
export const FETCH_COURSE_PACKAGES_START = 'FETCH_COURSE_PACKAGES_START';
export const FETCH_COURSE_PACKAGES_SUCCESS = 'FETCH_COURSE_PACKAGES_SUCCESS';
export const FETCH_COURSE_PACKAGES_FAIL = 'FETCH_COURSE_PACKAGES_FAIL';

export const FETCH_SINGLE_COURSE_PACKAGE_START = 'FETCH_SINGLE_COURSE_PACKAGE_START';
export const FETCH_SINGLE_COURSE_PACKAGE_SUCCESS = 'FETCH_SINGLE_COURSE_PACKAGE_SUCCESS';
export const FETCH_SINGLE_COURSE_PACKAGE_FAIL = 'FETCH_SINGLE_COURSE_PACKAGE_FAIL';
export const FETCH_SINGLE_COURSE_PACKAGE_UNMOUNT = 'FETCH_SINGLE_COURSE_PACKAGE_UNMOUNT';